<template>
     <v-flex justify="center">
       <RemoveWindow 
        v-model="dialogDelete2"  Type="Nurse"  :removeItem="removeItem"  Headline="Ta bort F(varning) för" WarningText="Har eleven klarat sig förbi sina hinder? Hurra för både eleven, dig och läraren, bra jobbat!"    />
 

      <v-dialog v-model="dialogAccessStart" persistent max-width="600px">
    <v-toolbar
      color="blue lighten-2"
      dark
    >
      <v-toolbar-title class="headline">  Överlämning {{removeItem.name }} 
            <v-icon dark @click="showTipSnackbar('Här kan du läsa och hantera den mottagna informationen gällande '+removeItem.name +'. Både från eleven själv samt dens föregående skola. ')"> info </v-icon></v-toolbar-title>
    </v-toolbar>
    <v-list  class="pa-4">
      <p class="body-2"> Överlämning av information gällande {{removeItem.name }}, skapad {{removeItem.reporter}}({{removeItem.hasOwnProperty('updated')? locfun.getDate( removeItem.updated): removeItem.changeDate}})</p>
       
  <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
     <p class="title font-weight-bold"  v-bind="attrs"  v-on="on"> Länk:</p>
   
           </template>      <span>Denna länk ska delas med {{removeItem.name}}s föregående skola.</span>  
             </v-tooltip>

         <p> https://app.ehtkollen.se/login#/startschool/{{removeItem.id}} </p>

 <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
     <p class="title font-weight-bold"  v-bind="attrs"  v-on="on"> Elev-länk:</p>
   
           </template>      <span>Denna länk ska delas med {{removeItem.name}}.</span>  
             </v-tooltip>

         <p> https://app.ehtkollen.se/login#/student/{{removeItem.id}} </p>

   <Overleave :getActivity="removeItem" ToFrom="Show" />

                       <v-spacer></v-spacer>
            <v-btn dark color="blue darken-1" @click="dialogAccessStart=false">
              Stäng
            </v-btn>
                        <v-btn dark color="red darken-1" @click="dialogDelete=true">
              Ta bort
            </v-btn>
        </v-list>

     
      </v-dialog>
<!-- Elev som har slutat -->
      <v-dialog v-model="dialogAccessEnd" persistent max-width="600px">
    <v-toolbar
      color="blue lighten-2"
      dark
    >
      <v-toolbar-title class="headline">  Överlämning {{removeItem.name }} 
            <v-icon dark @click="showTipSnackbar('Här ska du skriva in information som ska överlämnas till '+removeItem.name +'s nya skola. ')"> info </v-icon></v-toolbar-title>
    </v-toolbar>
    <v-list  class="pa-4">
      <p class="body-2"> Överlämning av information gällande {{removeItem.name }}, skapad {{removeItem.reporter}}({{removeItem.hasOwnProperty('updated')? locfun.getDate( removeItem.updated): removeItem.changeDate}})</p>
       
  <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
     <p class="title font-weight-bold"  v-bind="attrs"  v-on="on"> Länk:</p>
   
           </template>      <span>Denna länk ska delas med {{removeItem.name}}s nästkommande skola.</span>  
             </v-tooltip>

         <p> https://app.ehtkollen.se/login#/end/{{removeItem.id}} </p>

<Overleave :getActivity="removeItem"  ToFrom="From" />
   
                       <v-spacer></v-spacer>
            <v-btn dark color="blue darken-1" @click="dialogAccessEnd=false">
              Stäng
            </v-btn>
                        <v-btn dark color="red darken-1" @click="dialogDelete=true">
              Ta bort
            </v-btn>
        </v-list>

     
      </v-dialog>

      <v-dialog v-model="dialogAccess" persistent max-width="600px">
    <v-toolbar
      color="blue lighten-2"
      dark
    >
      <v-toolbar-title class="headline"> Information och återkoppling för {{removeItem.name }} 
            <v-icon dark @click="showTipSnackbar('Här kan du läsa detaljer om elevärendet och lämna feedback ifall det gäller f eller varning.')"> info </v-icon></v-toolbar-title>
    </v-toolbar>
    <v-list  class="pa-4">
      <p class="body-2"> Upprättad av {{removeItem.reporter}}({{removeItem.hasOwnProperty('updated')? locfun.getDate( removeItem.updated): removeItem.changeDate}})</p>
        <p class="title font-weight-bold">Typ:</p>
         <p >{{removeItem.typ}}</p>
        <p class="title font-weight-bold">Upplevd anledning:</p>

        <!-- <p class="title font-weight-bold">Härledande orsak:</p> -->
         <p >{{removeItem.cause}}</p>
     <p class="title font-weight-bold"> Åtgärdsplan:</p>
         <p >{{removeItem.plan}}</p>
         <div v-if="removeItem.hasOwnProperty('status')">
     <p class="title font-weight-bold"> Status:

  <v-tooltip bottom >
            <template v-slot:activator="{ on, attrs }">
    <span class='big ml-3 pt-3'     v-bind="attrs"  v-on="on"> {{removeItem.status}} </span>
   
           </template>      <span>{{status_text(removeItem.status)}}</span>  
             </v-tooltip>

     </p>
      
         </div>
         <p class="title font-weight-bold"> Återkoppling: </p>
              <v-textarea
          solo
          v-model="removeItem.feedback"
          name="input-7-4"
          label="Återkoppling på åtgärdsplan"
        ></v-textarea>   
                       <v-spacer></v-spacer>
            <v-btn dark color="blue darken-1" @click="update_Plan()">
              Stäng
            </v-btn>
                        <v-btn dark color="red darken-1" v-if="role=='rektor'" @click="dialogDelete2=true">
              Ta bort
            </v-btn>
        </v-list>

     
      </v-dialog>
   <RemoveWindow 
        v-model="dialogDelete"   Type="Nurse" :removeItem="removeItem"  Headline="Ta bort elevändring" WarningText="Är du säker på att du vill ta bort denna elevändring från EHTKollen? En elevändring som är
              borttagen går inte att återfå.."    />
    <div>
      <v-card class="mx-auto" max-width="1000" min-width="300">
        <v-toolbar class="pencil"   :color="ToolColor" dark @click="Loadin();Hide = !Hide">
          <v-toolbar-title>{{ Headline }}  
           
           </v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
                     
            <v-icon v-if="Hide == false" color="orange ligthen-1"
              >arrow_downward</v-icon >
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>

        </v-toolbar>
        
  <v-expand-transition>
        <div v-if="Hide">
          <div v-if="activites.length != 0">  
 <div class="light-blue ligthen-4 text-center">
    <span class="tt" color="white">datumregistrering när elev börjat eller slutat på aktuell skola samt F och kursvarningar.</span>
  </div>
  <v-timeline>
<template  v-for="item in activites" >

        <v-timeline-item v-if="item.activity=='slutat'"  :key="(item.name+item.time)"
          color="blue"  class="closer"  left>
          
 
              <strong>{{item.name}} har {{item.activity}} i {{item.class}}.</strong>

              <strong> {{item.changeDate}}</strong>
              <div class="caption">
             Inrapporterad av {{item.reporter}}  
            
  <v-btn  @click="
              removeItem = item;
              dialogAccessEnd = true;"
             dark color="blue ligthen-1">
   Överlämningsblanket
  </v-btn>
              </div>
          
        </v-timeline-item>
        <!-- F!!!! -->
                <v-timeline-item v-else-if="item.activity=='f'"  :key="(item.name+item.time)"
          color="red"  class="closer"  left>
          
 
              <strong>{{item.name}} i {{item.class}} har {{item.activity}}  inom {{item.course}}.</strong>

              <strong> {{locfun.getDate( item.time)}}</strong>
              <div class="caption">
             anmäld av {{item.reporter}}  
                <v-btn  @click="
              removeItem = item;removeItem.Oldfeedback=removeItem.feedback;
              dialogAccess = true;"
             dark color="red ligthen-1">
  <span id='big'> {{item.hasOwnProperty('status')?item.status:''}}</span> info
  </v-btn>
<!-- '<span class="button">'+item.status+'</span>' -->
              </div>
          
        </v-timeline-item>
<!-- FVARNING -->
                <v-timeline-item v-else-if="item.activity=='f-varning'" :key="(item.name+item.time)"
          color="yellow"  right>
            
              <strong> {{locfun.getDate( item.time)}}</strong>
 
              <strong> {{item.name}} i {{item.class}} har {{item.activity}}  inom {{item.course}}.</strong>

              <div class="caption">
             anmäld av {{item.reporter}}  
                <v-btn  @click="
              removeItem = item;removeItem.Oldfeedback=removeItem.feedback;
              dialogAccess = true;"
             dark color="yellow ligthen-1">
  <span id='big'> {{item.hasOwnProperty('status')?item.status:''}}</span> info
  </v-btn>

              </div>
          
        </v-timeline-item>

        <v-timeline-item v-else  :key="(item.name+item.time)"
          color="green"
          right
        >
              <strong>{{item.changeDate}}</strong>
              <strong> {{item.name}} har {{item.activity}} i {{item.class}}.</strong>
              <div class="caption">
             Inrapporterad av {{item.reporter}}
                 <!-- <v-btn @click="
              removeItem = item;
              dialogDelete = true;" dark color="red ligthen-1">
   Ta bort
  </v-btn> -->
    <v-btn  @click="
              removeItem = item;
              dialogAccessStart = true;"
             dark color="green ligthen-1">
   Överlämningsblanket
  </v-btn>
              </div>
        </v-timeline-item>
        </template>
  </v-timeline>


        </div>  
            <div v-else  class="bellowPen" :class="ToolColor+ ' lighten-1 text-center'">  
    <span class="tt" color="white">Det finns inga elevförändringar.</span>
      <v-btn @click="send=true" dark color="green ligthen-1">
    Lägg till elevförändring
  </v-btn>
  <SendtoNurse :schoolId="schoolId" As="EHT"  :reporter="person.name"    v-model="send" />
    </div>
        </div>
       
  </v-expand-transition>
      </v-card>
    </div>
</v-flex>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import RemoveWindow from "./assets/RemoveWindow.vue";
import Overleave from "../components/StudentChange/Overleave.vue";
import fun from "./functions";
import SendtoNurse from './SendtoNurse.vue';
export default {
  name:"NurseActivity",
  props: {
    schoolId: String,
    Headline: String,
    ToolColor: String,
    role: String,
    person: Object
  },
  
  components: {
    RemoveWindow, Overleave,SendtoNurse
  },
  computed: {
    activites(){
//  (this.nurseActivities)
//  if(this.currentItemList != undefined) {
    var active = JSON.parse(JSON.stringify(this.nurseActivities))
    this.nurseActivities.forEach(element => {
      active
    });
    for (let i = 0; i <  this.nurseActivities.length; i++) {
      active[i].id =  this.nurseActivities[i].id;
      
    }
  active.sort(function(a, b) {
      var c = new Date(a.changeDate);
      var d = new Date(b.changeDate);
      return c-d;
  })

//  (active)
return active;
}
,



    ...mapGetters("ehtmembers", ["nurseActivities",'nurseActivityFetched']),
  },
  created() {

     this.locfun= new fun();
         
 
},
  methods: {
    ...mapActions('ehtmembers', ['NurseActivityGet']),
    ...mapActions(['showTipSnackbar','showSuccessSnackbar']),
    ...mapActions("ehtmembers", ["updatePlan"]),

    ...mapActions('ehtmembers', ['NurseActivityGet']),
    Loadin()
    {
    if (this.nurseActivityFetched==false) {
      //console.log("Fetched");
      this.NurseActivityGet(this.schoolId);
}  
    },

    status_text(smiley){
      
      return this.smiles.find(s => s.smile == smiley).text
    },
update_Plan(){
    this.removeItem.Type="feedback";
if (this.removeItem.hasOwnProperty('feedback') && this.removeItem.Oldfeedback==null) {
    delete this.removeItem.Oldfeedback;
this.updatePlan(this.removeItem);
this.showSuccessSnackbar("Återkoppling är given.")
}
  else if (this.removeItem.feedback != this.removeItem.Oldfeedback) {
    delete this.removeItem.Oldfeedback;
this.updatePlan(this.removeItem);
this.showSuccessSnackbar("Återkoppling är uppdaterad.")
  }
this.dialogAccess = false;

},


  },
  data() {
    return {
        Hide: false,
      dialogAccess: false,
      send: false,
      dialogAccessEnd: false,
      dialogAccessStart: false,
      dialog: false,
          removeItem: { name: "temp", id: "temp" },
      dialogDelete: false,
      dialogDelete2: false,
       smiles:   [ { smile:"😳", text:"önskar stöttning"}, {smile: "😌", text:"arbetet går framåt"}, { smile:"🤓" , text:"eleven är nära måluppfyllelse "}, { smile:"🥳", text:" eleven har kompletterat"}, { smile:'🤩' ,text:"eleven har uppnått målbilden"}],
 
    };
  },
};
</script>

<style scoped>
#big {
  font-size: 30px;
}
.tt{
  color: white;
  font-size: 1.34em;
  margin: 30px;
}
.text-center{
 margin-right: 5% !important;
 margin-left: 0.4% !important;
}
.closer{
  margin-left:10%;
}
</style>